import { FunctionComponent } from 'react';
import { ViewProps } from './types';
import { Heading } from './styles';

/**
 * A heading is the main heading of a section and
 * should therefore appear only once per section.
 */
const View: FunctionComponent<ViewProps> = (props) => (
  <Heading className="Heading" {...props} />
);

export default View;
